import type { ReactNode } from 'react';
import { useState } from 'react';
import type { IEpisodeContext } from './EpisodeContext';
import { EpisodeContext } from './EpisodeContext';

interface IEpisodeContextProviderProps {
    children: (value: Pick<IEpisodeContext, 'autoSaveStatus'>) => ReactNode;
    value: Omit<IEpisodeContext, 'autoSaveStatus' | 'setAutoSaveStatus'>;
}

export function EpisodeContextProvider({ children, value }: IEpisodeContextProviderProps) {
    const [autoSaveStatus, setAutoSaveStatus] = useState<IEpisodeContext['autoSaveStatus']>('idle');

    return (
        <EpisodeContext.Provider value={{ ...value, autoSaveStatus, setAutoSaveStatus }}>
            {children({ autoSaveStatus })}
        </EpisodeContext.Provider>
    );
}
